/**
 * Check if an element represented by the given
 * selector exists on the current page
 *
 * @param selector
 */
export function hasElement(selector: string): boolean {
    return document.querySelector(selector) !== null;
}
